import Swal, { SweetAlertResult } from "sweetalert2"

export const unpostingAlert = async (): Promise<SweetAlertResult<any>> =>
  await Swal.fire({
    title: "Are you sure want to continue?",
    showCancelButton: true,
    confirmButtonText: "UNPOSTING",
    cancelButtonText: "CANCEL",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-error"
    }
  })
